<div class="checkin-container">
 <!-- Close button -->
  <button
    mat-icon-button
    class="close-btn"
    aria-label="Cerrar"
    (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
  <h2>Check-In<span class="material-icons gps" (click)="onSecretClick()">gps_fixed</span></h2>
<div class="row">
  <div class="col-md-6 sidebuton">
      <button matMiniFab style="left: 10px;"  color="primary" (click)="openCheckin()">
 <span class="material-icons">visibility</span>
  </button>
  <button mat-flat-button color="primary" (click)="getLocation()">
    Obtener mi ubicación
  </button>

</div><div class="col-md-6">
       @if(geofenceStatus === 'dentro' && esadmin){
    <button mat-flat-button color="accent" (click)="doCheckIn(false)">Check-In</button>
   <!-- <span class="ok">Estás dentro del área autorizada.</span> -->
}

@if(geofenceStatus === 'fuera'){
  <span class="error">⚠ Estás fuera del área permitida.</span>
}
  @if(errorMessage){
    <p class="error">{{ errorMessage }}</p>
  }
  </div>
</div>
<div class="row">
  <h3>Check-Ins Pendientes</h3>
  <!-- <div class="col-md-10 sidebuton">
    <ul>
      <li *ngFor="let checkin of checkinsPending">
        {{ checkin.day_name }} - {{ checkin.shift_start }} - {{ checkin.checkintime ? ` Registrado ${checkin.checkintime}` : `\<button mat-flat-button color="accent" (click)="doCheckIn()">Check-In\</button>` }}
        </li>
    </ul>
  </div> -->

  <li *ngFor="let checkin of checkinsPending">
       <div style="text-align: left;">
  {{ checkin.day_name }} - {{ checkin.shift_start }} -

  <span *ngIf="checkin.checkintime; else btn">
    Registrado {{ checkin.checkintime }}
  </span>

  <ng-template #btn>
   @if(geofenceStatus === 'dentro'){
       <button matButton="outlined" class="checkin" (click)="doCheckIn(checkin)">
      Check-In
    </button>
  }@else {
    Pendiente
  }
  </ng-template>
      </div>
</li>

  </div>
@if(loading){
<div class="svg-loader">
    <img src="assets/images/dots.svg" alt="Cargando..." />

</div>
}
  <div id="map" class="map"></div>

  @if(coords){
    <div class="info-box">
      <div class="row">
        <div class="col-md-4">
          <p><strong>Lat:</strong> {{ coords.lat }}</p>
        </div>
        <div class="col-md-4">
          <p><strong>Lng:</strong> {{ coords.lng }}</p>
        </div>
        <div class="col-md-4">
          <p><strong>Precisión:</strong> {{ coords.accuracy }} metros</p>
        </div>
      </div>
    </div>
  }

</div>
